import type { AppRoute } from '@/types/router';

export enum UserRole {
  residentSupporter = ':ddm-smartheating:resident-supporter',
}

export type RouteAccess = {
  canAccess: boolean;
  redirectTo?: AppRoute;
};
